import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mainTitle: 'Select',
  selectedOption: null,
  step: 0,
  disableNext: [],
  disablePrev: [],
  formData: {
    userName: '',
    email: '',
    password: '',
  },
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setMainTitle: (state, action) => {
      state.mainTitle = action.payload;
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setDisableNext: (state, action) => {
      const copyDisableNext = [...state.disableNext];
      copyDisableNext[action.payload.number] = action.payload.disabled;
      state.disableNext = copyDisableNext;
    },
    setDisablePrev: (state, action) => {
      const copyDisablePrev = [...state.disablePrev];
      copyDisablePrev[action.payload.number] = action.payload.disabled;
      state.disablePrev = copyDisablePrev;
    },

    setField: (state, action) => {
      const { field, value } = action.payload;
      if (field in state.formData) {
        state.formData[field] = value;
      }
    },
  },
});

const {
  setData,
  setMainTitle,
  setSelectedOption,
  setStep,
  setDisableNext,
  setDisablePrev,
  setField,
} = dataSlice.actions;

export {
  setData,
  setMainTitle,
  setSelectedOption,
  setStep,
  setDisableNext,
  setDisablePrev,
  setField,
};

export default dataSlice.reducer;
